export enum WebViewNativeMethods {
  CLOSE = 'CLOSE',
}
